// 应用初始状态
const state = {
    connections:[]
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/database/state.js